(() => {
const usProvinceNames = {
  AA: 'Armed Forces Americas', AE: 'Armed Forces Europe', AK: 'Alaska', AL: 'Alabama',
  AP: 'Armed Forces Pacific', AR: 'Arkansas', AS: 'American Samoa', AZ: 'Arizona',
  CA: 'California', CO: 'Colorado', CT: 'Connecticut', DC: 'District of Columbia',
  DE: 'Delaware', FL: 'Florida', FM: 'Federated States of Micronesia', GA: 'Georgia',
  GU: 'Guam', HI: 'Hawaii', IA: 'Iowa', ID: 'Idaho', IL: 'Illinois', IN: 'Indiana',
  KS: 'Kansas', KY: 'Kentucky', LA: 'Louisiana', MA: 'Massachusetts', MD: 'Maryland',
  ME: 'Maine', MH: 'Marshall Islands', MI: 'Michigan', MN: 'Minnesota', MO: 'Missouri',
  MP: 'Northern Mariana Islands', MS: 'Mississippi', MT: 'Montana', NC: 'North Carolina',
  ND: 'North Dakota', NE: 'Nebraska', NH: 'New Hampshire', NJ: 'New Jersey', NM: 'New Mexico',
  NV: 'Nevada', NY: 'New York', OH: 'Ohio', OK: 'Oklahoma', OR: 'Oregon', PA: 'Pennsylvania',
  PR: 'Puerto Rico', RI: 'Rhode Island', SC: 'South Carolina', SD: 'South Dakota',
  TN: 'Tennessee', TX: 'Texas', UT: 'Utah', VA: 'Virginia', VI: 'Virgin Islands',
  VT: 'Vermont', WA: 'Washington', WI: 'Wisconsin', WV: 'West Virginia', WY: 'Wyoming',
  PW: 'Palau',
};

if (!customElements.get('kk-shipping-location')) {
  customElements.define('kk-shipping-location', class extends HTMLElement {
    connectedCallback() {
      customElements.whenDefined('shipping-calculator').then(() => {
        if (!this.isConnected) return;

        this.calculator = this.closest('shipping-calculator');
        this.country = this.calculator?.querySelector('#ShippinCalculator-Countries');
        this.province = this.calculator?.querySelector('#ShippinCalculator-Provinces');
        this.postalCode = this.calculator?.querySelector('#ShippinCalculator-PostalCode');
        this.calculateButton = this.calculator?.querySelector('#ShippinCalculator-CalculateButton');
        if (!this.country || !this.province || !this.postalCode || !this.calculateButton) return;

        let attempts = 0;
        const connect = () => {
          if (!this.isConnected) return;
          if (this.country.value === 'United States' && !this.province.options.length && attempts++ < 30) {
            requestAnimationFrame(connect);
            return;
          }

          this.country.addEventListener('change', this.syncLocation);
          this.postalCode.addEventListener('input', this.syncLocation);
          this.calculateButton.addEventListener('click', this.validateLocation, true);
          this.postalCode.addEventListener('keyup', this.validateEnter, true);
          this.originalShowResults = this.calculator.showResults;
          this.calculator.showResults = this.showFormattedResults;
          this.syncLocation();
        };

        connect();
      });
    }

    disconnectedCallback() {
      this.country?.removeEventListener('change', this.syncLocation);
      this.postalCode?.removeEventListener('input', this.syncLocation);
      this.calculateButton?.removeEventListener('click', this.validateLocation, true);
      this.postalCode?.removeEventListener('keyup', this.validateEnter, true);
      if (this.calculator?.showResults === this.showFormattedResults) {
        this.calculator.showResults = this.originalShowResults;
      }
      this.originalShowResults = null;
    }

    showFormattedResults = rates => {
      this.originalShowResults(rates);
      const items = this.calculator.querySelectorAll('.shipping-calculator__results li');
      const locale = document.documentElement.lang || 'en-US';

      rates.forEach((rate, index) => {
        const amount = Number(rate.price);
        if (!items[index] || !Number.isFinite(amount)) return;

        try {
          const price = new Intl.NumberFormat(locale, {
            style: 'currency',
            currency: rate.currency || this.calculator.dataset.currency,
            currencyDisplay: 'narrowSymbol',
          }).format(amount);
          items[index].textContent = `${rate.name}: ${price}`;
        } catch {
          // Keep the theme's original rate text if the currency cannot be formatted.
        }
      });
    };

    syncLocation = () => {
      const countryField = this.country.closest('.shipping-calculator__field');
      const provinceField = this.province.closest('.shipping-calculator__field');
      countryField.hidden = this.country.options.length === 1 && this.country.value === 'United States';

      if (this.country.value !== 'United States') {
        this.postalCode.required = false;
        this.postalCode.removeAttribute('pattern');
        this.postalCode.inputMode = 'text';
        this.province.required = false;
        return;
      }

      this.postalCode.required = true;
      this.postalCode.pattern = '[0-9]{5}(-[0-9]{4})?';
      this.postalCode.inputMode = 'numeric';

      const zip = this.postalCode.value.trim();
      const isComplete = /^\d{5}(?:-\d{4})?$/.test(zip);
      const state = isComplete ? usProvinceNames[window.zipState?.(zip)] : null;
      const option = Array.from(this.province.options).find(item => item.value === state);

      if (option) this.province.value = option.value;
      if (isComplete && !option && this.lastUnmappedZip !== zip) this.province.selectedIndex = -1;
      this.lastUnmappedZip = isComplete && !option ? zip : null;

      provinceField.hidden = !!option || !isComplete;
      this.province.required = isComplete && !option;
    };

    validateLocation = event => {
      this.syncLocation();
      if (this.country.value !== 'United States') return;
      if (!this.postalCode.reportValidity() || !this.province.reportValidity()) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    };

    validateEnter = event => {
      if (event.key === 'Enter') this.validateLocation(event);
    };
  });
}
})();
